import View from 'cdna/core/view';
import EntryView from './entryView.js';

export default View.extend({    
    tagName: 'div',
    bindings: {   
        'Id': 'attr data-nav',
        'Entries': 'collection entryBinding entryBinder'
    },
    entryBinding: {
        itemView: EntryView
    }
});


/** WEBPACK FOOTER **
 ** ./client/guide/guidePageView.js
 **/